import {Injectable} from '@angular/core';
import {BehaviorSubject, filter, map, Observable} from "rxjs";
import {ActivatedRouteSnapshot, NavigationEnd, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RouteTitleService {

  private readonly titleSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  currentTitle$: Observable<string> = this.titleSubject.asObservable();

  constructor(
    private readonly router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.getDeepestRouteTitle(this.router.routerState.snapshot.root))
    ).subscribe({
      next: (title: string) => {
        this.titleSubject.next(title)
      }
    });
  }

  private getDeepestRouteTitle(route: ActivatedRouteSnapshot): string {
    let title: string = '';
    if (route.firstChild) {
      title = this.getDeepestRouteTitle(route.firstChild);
    }
    return title || route.data['title'] || '';
  }
}
